import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MerchantService } from '../_services/merchant.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthPrivateGuard  {
  private readonly router: Router = inject(Router);
  private readonly merchantService: MerchantService = inject(MerchantService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.merchantService.checkSession();
    if (this.merchantService.currentMerchant && this.merchantService.accessAllowed) {
      return true;
    } else {
      return this.merchantService.isLoggedIn().pipe(map(
        (isLoggedIn) => {
          if (isLoggedIn) {
            return true;
          } else {
            this.router.navigate(['public/home'], {});
            return false;
          }
        }
      ));
    }
  }

}
